export default {
  editTournament: (tenant, tournamentId) => `/${tenant}/tournaments/${tournamentId}/edit`,
  manageFlights: (tenant, tournamentId) => `/${tenant}/tournaments/${tournamentId}/flights/edit`,
  manageTournamentCategories: (tenant, tournamentId) =>
    `/${tenant}/tournaments/${tournamentId}/categories/edit`,
  newTournamentCategory: (tenant, tournamentId) =>
    `/${tenant}/tournaments/${tournamentId}/categories/new`,
  editTournamentCategory: (tenant, tournamentId, categoryId) =>
    `/${tenant}/tournaments/${tournamentId}/categories/${categoryId}/edit`,
  managePlayers: (tenant, tournamentId) => `/${tenant}/tournaments/${tournamentId}/players/edit`,
  viewFlights: (tenant, tournamentId) => `/${tenant}/tournaments/${tournamentId}/flights`,
  liveFlights: (tenant, tournamentId, round) =>
    `/${tenant}/tournaments/${tournamentId}/flights/live/${round}`,
  viewResults: (tenant, tournamentId) => `/${tenant}/tournaments/${tournamentId}/results`,
  viewTeamResults: (tenant, tournamentId) => `/${tenant}/tournaments/${tournamentId}/teamResults`,
  manageFlightResults: (tenant, tournamentId, flightId) =>
    `/${tenant}/tournaments/${tournamentId}/flights/${flightId}/manageResults`,
  flightResults: (tenant, tournamentId, flightId) =>
    `/${tenant}/tournaments/${tournamentId}/flights/${flightId}/results`,
  playerResults: (tenant, tournamentId, flightId) =>
    `/${tenant}/tournaments/${tournamentId}/players/${flightId}/results`,
  editPlayer: (tenant, playerId) => `/${tenant}/players/${playerId}/edit`,
  viewTournamentStatistics: (tenant, tournamentId) =>
    `/${tenant}/tournaments/${tournamentId}/statistics`,
  manageCategories: (tenant) => `/${tenant}/categories`,
  editCategory: (tenant, categoryId) => `/${tenant}/categories/${categoryId}/edit`,
  championshipResults: (tenant, championshipId) =>
    `/${tenant}/championships/${championshipId}/results`,
  manageTeams: (tenant) => `/${tenant}/teams`,
  editTeam: (tenant, teamId) => `/${tenant}/teams/${teamId}/edit`,
}



// WEBPACK FOOTER //
// ./src/helpers/routes.ts